export const testimonials = [
  {
    id: 1,
    comment:
      "Imagive completely changed how we approach ad creatives. Earlier, we were just testing randomly, but now we clearly understand what hooks and formats work in our category. It’s helped us make smarter decisions faster.",
    name: "Aakash Sharma",
    role: "Performance Marketer",
    image: "/assets/homePage/testimonial/male-1.jpeg",
    rotate: "lg:rotate-[5deg]",
  },
  {
    id: 2,
    comment:
      "We were spending a lot on ads without real clarity. Imagive showed us exactly where our messaging was weak and what competitors were doing better. The insights are super actionable, not just data.",
    name: "Riya Mehta",
    role: "D2C Founder",
    image: "/assets/homePage/testimonial/female-1.jpeg",
    rotate: "lg:-rotate-[7deg]",
  },
  {
    id: 3,
    comment:
      "The competitor analysis is honestly the best part. Within minutes, I could see patterns across brands—what’s working, what’s overused, and where we can stand out. It saves hours of manual research.",
    name: "Kunal Verma",
    role: "Growth Lead",
    image: "/assets/homePage/testimonial/male-2.jpeg",
    rotate: "lg:rotate-[5deg]",
  },
  {
    id: 4,
    comment:
      "This feels like having a strategist built into the product. It doesn’t just show insights, it tells you what to do next. We improved our creatives and messaging direction within weeks.",
    name: "Neha Kapoor",
    role: "Marketing Manager",
    image: "/assets/homePage/testimonial/female-2.jpeg",
    rotate: "lg:-rotate-[8deg]",
  },
  {
    id: 5,
    comment:
      "Hook analysis alone made a huge difference for us. We started testing better messaging angles and saw noticeable improvement in engagement. It takes the guesswork out of ad creatives.",
    name: "Arjun Singh",
    role: "Paid Ads Specialist",
    image: "/assets/homePage/testimonial/male-3.jpeg",
    rotate: "lg:rotate-[6deg]",
  },
  {
    id: 6,
    comment:
      "Imagive helped us move beyond discount-heavy ads. We started focusing more on storytelling and positioning, which made our brand feel stronger and more premium.",
    name: "Sneha Jain",
    role: "Brand Strategist",
    image: "/assets/homePage/testimonial/female-3.jpeg",
    rotate: "lg:-rotate-[6deg]",
  },
  {
    id: 7,
    comment:
      "What used to take hours of competitor research now takes minutes. The platform is fast, intuitive, and gives exactly the kind of insights you need to take action.",
    name: "Rahul Bansal",
    role: "Ecommerce Operator",
    image: "/assets/homePage/testimonial/male-4.jpeg",
    rotate: "lg:rotate-[5deg]",
  },
  {
    id: 8,
    comment:
      "If you're running ads, this tool is a no-brainer. It gives you clarity on creatives, messaging, and strategy in one place. It’s become a core part of our workflow.",
    name: "Priya Nair",
    role: "Founder, Lifestyle Brand",
    image: "/assets/homePage/testimonial/female-4.jpeg",
    rotate: "lg:-rotate-[7deg]",
  },
];
